module.exports = __webpack_public_path__ + "img/t4-name.3c97f838.png";